import { render, staticRenderFns } from "./PdfmdpsepIndextab8.vue?vue&type=template&id=3a19960d"
import script from "./PdfmdpsepIndextab8.vue?vue&type=script&lang=js"
export * from "./PdfmdpsepIndextab8.vue?vue&type=script&lang=js"
import style0 from "./PdfmdpsepIndextab8.vue?vue&type=style&index=0&id=3a19960d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports